import {
  AuthContext,
  Provider,
  useAuth
} from "./chunk-LOV7QXJW.mjs";

// src/index.ts
import { Stage as Stage3 } from "@efishery/sdk-core";

// src/libs/Auth.ts
import { Auth, Stage } from "@efishery/sdk-core";

// src/providers/Efishery.provider.ts
import { createElement, useEffect, useState, useCallback } from "react";
import { Auth as Auth2 } from "@efishery/sdk-core";
var EfisheryProvider = ({
  children,
  clientId,
  stage,
  redirectUrl,
  failedRedirectUrl
}) => {
  const [authenticateStatus, setAuthenticateStatus] = useState("loading");
  const [profile, setProfile] = useState(null);
  const auth = new Auth2(clientId, stage);
  const getProfile = useCallback(async () => {
    setAuthenticateStatus("loading");
    if (!auth.isSignedAsLogged()) {
      setAuthenticateStatus("rejected");
      return;
    }
    try {
      const profileFromSDK = await auth.getProfile();
      setProfile(profileFromSDK.data);
      setAuthenticateStatus("authenticated");
    } catch (err) {
      setAuthenticateStatus("rejected");
    }
  }, [auth, setProfile, setAuthenticateStatus]);
  useEffect(() => {
    getProfile();
  }, []);
  const value = {
    authenticateStatus,
    setAuthenticateStatus,
    auth,
    clientId,
    stage: auth._stage,
    redirectUrl,
    failedRedirectUrl,
    profile,
    setProfile
  };
  return createElement(Provider, { value }, children);
};
export {
  AuthContext,
  EfisheryProvider,
  Provider,
  Stage3 as Stage,
  useAuth
};
